// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"item_EfDFo","title":"title_3QE6C","content":"content_2K74q","intro":"intro_1fLwN","contact":"contact_8QLBl","contact_list":"contact_list_3zwaB"};